<script lang="ts">
    import { apiBaseOverride } from "../../store"
    import blocks from "./blocks"
    import CrinkledSection from "../CrinkledSection.svelte"
    import MedialibImage from "../widgets/MedialibImage.svelte"
    export let block: ContentBlock,
        allwaysInView: boolean = false,
        apiBase: string = null
    if (apiBase) $apiBaseOverride = apiBase
    $: blockComponent = blocks[block.type] || blocks.default
</script>

<CrinkledSection activated="{block.crinkledSection || false}">
    <section
        class:additionalHeightAtBottom="{block.additionalHeightBottom}"
        class:headerHeightUp="{block.background.headerHeightUp}"
        data-type="{block.type}"
        class="minheight-{block?.background?.minHeight} {block.padding?.top ? 'tp-' + block.padding.top : ''} {block
            .padding?.bottom
            ? 'bp-' + block.padding.bottom
            : ''} {blockComponent.sectionClass} {block.background?.color ? block.background.color + '-bg' : ''}"
    >
        {#if block.background?.image}
            <div class="background-image">
                <figure>
                    <MedialibImage id="{block.background.image}" />
                    {#if block.background?.overlay}
                        <div class="overlay"></div>
                    {/if}
                </figure>
            </div>
        {/if}
        <section
            class="content"
            class:narrowWidth="{block.contentWidth == 1}"
            class:normalWidth="{block.contentWidth == 2}"
            class:fullWidth="{block.contentWidth == 0}"
        >
            <div class="wrapper">
                {#if block.headline || block.subline}
                    <div class="container bp-xl">
                        <!-- Überschrift Element -->
                        {#if block.headline}
                            {#if block.headlineH1}
                                <h1 class="h2">{block.headline}</h1>
                            {:else}
                                <h2>{block.headline}</h2>
                            {/if}
                        {/if}
                        {#if block.subline}
                            <h3>{block.subline}</h3>
                        {/if}
                    </div>
                {/if}

                <svelte:component
                    this="{blockComponent.component}"
                    block="{block}"
                />
            </div>
        </section>
    </section>
</CrinkledSection>

<style lang="less">
    @import "../../../lib/assets/css/variables.less";
    section {
        position: relative;
        width: 100%;

        &.additionalHeightAtBottom {
            padding-bottom: 3rem;
        }
        &.headerHeightUp {
            margin-top: -86px;
        }
        &.minheight-normal {
            height: 38rem;
            min-height: 75vh;
            @media @mobile {
                height: initial;
            }
        }
        &.minheight-extended {
            padding-top: 145px;
            height: calc(38rem + 145px);
            min-height: 75vh;
        }
        .content {
            position: relative;
            z-index: 2;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            .wrapper {
                padding: var(--vertical-default-margin) 0px;
                margin: 0px var(--horizontal-default-margin);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                width: calc(100% - var(--horizontal-default-margin));
                max-width: calc(100% - var(--horizontal-default-margin));
                height: 100%;
            }
            &.narrowWidth {
                .wrapper {
                    max-width: var(--small-max-width);
                }
            }

            &.normalWidth {
                .wrapper {
                    max-width: var(--normal-max-width);
                }
            }
        }
        .background-image {
            z-index: 1;
            top: 0px;
            left: 0px;
            right: 0px;
            position: absolute;
            width: 100%;
            height: 100%;
            figure {
                width: 100%;
                height: 100%;
                position: relative;
                .overlay {
                    position: absolute;
                    z-index: 100;
                    background-color: rgba(32, 28, 28, 0.3);
                    width: 100%;
                    height: 100%;
                    top: 0px;
                    left: 0px;
                    right: 0px;
                }
            }
        }
    }
    :global .background-image > figure > img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
</style>
